<template>
  <div>
    <div :class="(loading ? 'show-loader' : 'hide-loader')">
      <div class="el-loading-spinner">
        <svg viewBox="25 25 50 50" class="circular">
          <circle cx="50" cy="50" r="20" fill="none" class="path"></circle>
        </svg><!---->
      </div>
    </div>
    <div class="row">
      <div class="col-lg-6 col-md-10 col-sm-12 pad-to-15">
        <div class="card">
            <div class="row card-content">
              <div class="col-md-12">
                <h6 class=""><img class="icon-card-header" src="/static/img/icons/user-sm.png"> {{$t('customers.title')}}</h6>
                <hr style="clear:both;" class="sm">
              </div>
              <div class="col-md-12">
                <div class="row pad-bt-10">
                  <div class="col-lg-5 col-sm-6 col-xs-12 details-label">{{$t('customers.id')}}</div>
                  <div class="col-lg-7 col-sm-6 col-xs-12"><b>{{customer.id}}</b></div>
                </div>
              </div>
              <div class="col-md-12">
                <div class="row pad-bt-10">
                  <div class="col-lg-5 col-sm-6 col-xs-12 details-label">{{$t('customers.name')}}</div>
                  <div class="col-lg-7 col-sm-6 col-xs-12"><b>{{customer.firstname}} {{customer.lastname}}</b></div>
                </div>
              </div>
              <div class="col-md-12">
                <div class="row pad-bt-10">
                  <div class="col-lg-5 col-sm-6 col-xs-12 details-label">{{$t('customers.email')}}</div>
                  <div class="col-lg-7 col-sm-6 col-xs-12"><b>{{customer.email}} </b></div>
                </div>
              </div>
              <div class="col-md-12">
                <div class="row pad-bt-10">
                  <div class="col-lg-5 col-sm-6 col-xs-12 details-label">{{$t('customers.phone')}}</div>
                  <div class="col-lg-7 col-sm-6 col-xs-12"><b>{{customer.phone}}</b></div>
                </div>
              </div>
              <div class="col-md-12">
                <div class="row pad-bt-10">
                  <div class="col-lg-5 col-sm-6 col-xs-12 details-label">{{$t('customers.gender')}}</div>
                  <div class="col-lg-7 col-sm-6 col-xs-12"><b>{{customer.gender}}</b></div>
                </div>
              </div>
              <div class="col-md-12">
                <div class="row pad-bt-10">
                  <div class="col-lg-5 col-sm-6 col-xs-12 details-label">{{$t('customers.birth')}}</div>
                  <div class="col-lg-7 col-sm-6 col-xs-12"><b>{{formatDate(customer.birthdate)}}</b></div>
                </div>
              </div>
              <div class="col-md-12">
                <div class="row pad-bt-10">
                  <div class="col-lg-5 col-sm-6 col-xs-12 details-label">{{$t('customers.location')}}</div>
                  <div class="col-lg-7 col-sm-6 col-xs-12">
                    <template v-if="customer.addresses !== undefined && customer.addresses.address_shipping !== undefined">
                      {{customer.addresses.address_shipping.join()}}
                    </template>
                    <template v-else>
                      <b>-</b>
                    </template>
                  </div>
                </div>
              </div>
              <div class="col-md-12">
                <div class="row pad-bt-10">
                  <div class="col-lg-5 col-sm-6 col-xs-12 details-label">{{$t('customers.pointsTitle')}}</div>
                  <div class="col-lg-7 col-sm-6 col-xs-12"><b>{{customer.loyalty_points}}</b></div>
                </div>
              </div>
            </div>
        </div> <!-- end card -->
      </div> <!--  end col-md-12  -->  
      <div class="col-lg-6 col-md-10 col-sm-12 pad-to-15">
        <div class="card">
          <div class="row card-content">
     <!--        <div class="col-md-12">
              <h6 class="">{{$t('customers.pointsTitle')}}</h6>
              <hr style="clear:both;" class="sm">
            </div>
            <div class="col-md-12">
              <div class="row pad-bt-10 ">
                <div class="col-lg-5 col-sm-6 col-xs-12 details-label">{{$t('customers.currentPoints')}}</div>
                <div class="col-lg-7 col-sm-6 col-xs-12"><b>{{customer.loyalty_points}}</b></div>
              </div>
            </div> -->
            <div class="col-md-12 pad-to-10">
              <h6 class="">{{$t('customers.pointsAddTitle')}}</h6>
              <hr style="clear:both;" class="sm">
            </div>
            <div class="col-md-12">
              <div class="form-group">
                <label class="details-label mar-rt-10">{{$t('customers.pointsLabel')}} ({{currency}})</label>
                <input type="number"
                        min="1" 
                       v-validate=""
                       v-model="newPoints.money_spent"
                       class="form-control">
              </div>
              <div class="form-group">
                <label class="details-label mar-rt-10">{{$t('customers.commentsLabel')}}</label>
                <textarea type="number"
                        min="1" 
                       v-validate=""
                       v-model="newPoints.comments"
                       rows="2" 
                       class="form-control "></textarea>
                
              </div>
              <button class="btn btn-fill btn-success" @click.prevent="addPoints">{{$t('general.add')}}</button>
            </div>
          </div>
        </div>
      </div>
      <div class="col-lg-12 col-md-12">
        <div class="card mar-bt-0">
          <div class="row card-content">
            <data-tables class=""
                      :data="customer.orders"
                      :action-def="defaultActionDef"
                      :pagination-def="paginationDef"
                      :table-props="{'border': false}" 
                      style="width: 100%"
                      @row-click="goToRecord">
              <el-table-column
                :min-width="70"
                sortable
                prop="number"
                :label="$t('customers.number')">
                <template slot-scope="props">
                  <b>#{{props.row.token}}</b>
                </template>
              </el-table-column>
              <el-table-column
                :min-width="70"
                sortable
                prop="date"
                :label="$t('customers.dateCreated')">
                <template slot-scope="props">
                  {{formatDateTime(props.row.created_at)}}
                </template>
              </el-table-column>
              <el-table-column
                :min-width="50"
                sortable
                prop="delivery_type"
                :label="$t('customers.delivery')">
                <template slot-scope="props">
                  {{props.row.delivery_type ? $t('deliveryTypes.' + props.row.delivery_type) : '-'}}
                </template>
              </el-table-column>
              <el-table-column
                :min-width="40"
                sortable
                prop="order_type"
                :label="$t('customers.type')">
                <template slot-scope="props">
                  <span :class="'text-lowercase'">
                  {{$t('ordersTypes.' + props.row.order_type)}}
                </span>
                </template>
              </el-table-column>
              <el-table-column
                :min-width="60"
                sortable
                prop="status"
                :label="$t('customers.status')">
                <template slot-scope="props">
                  <span :class="'label label-' + orderStatusClass(props.row.status.id)">{{$t('ordersStatus.' + props.row.status.id)}}</span>
                </template>
              </el-table-column>
              <el-table-column
                :min-width="60"
                :class="'text-right'"
                sortable
                prop="total"
                :label="$t('customers.total')">
                <template slot-scope="props">
                  <b>{{formatMoneyAmount(props.row.totals_grandtotal, props.row.currency)}}</b>
                </template>
              </el-table-column>
              <el-table-column
                :width="45">
                <template slot-scope="props"><i class="fa fa-pencil"></i></template>
              </el-table-column>
            </data-tables>
            <div class="cust-sales">
              <div class="pull-right">
                <span class="details-label">{{$t('customers.allTimeSale')}}:</span><b> {{formatMoneyAmount(customer.sales)}}</b>
              </div>
            </div>
            
          </div>
        </div> <!-- end card -->
      </div> <!--  end col-md-12  --> 
    </div>
  </div>
</template>
<script>
  import Vue from 'vue'
  import {Select, Option, DatePicker} from 'element-ui'
  import countriesList from './countries'
  import DataTables from 'vue-data-tables'
  import swal from 'sweetalert2'
  Vue.use(Select)
  Vue.use(DatePicker)
  Vue.use(DataTables)
  export default {
    components: {
      [Select.name]: Select,
      [Option.name]: Option,
      [DatePicker.name]: DatePicker
    },
    created: function () {
      this.getData()
    },
    data () {
      return {
        loading: true,
        customer: [],
        newPoints: {
          money_spent: null,
          comments: null
        },
        countries: countriesList,
        currency: '',
        modelValidations: {
          required: {
            required: true
          }
        },
        paginationDef: {
          pageSize: 10,
          currentPage: 1,
          pageSizes: [10, 25, 50],
          show: true
        }
      }
    },
    methods: {
      getData () {
        this.$nextTick(function () {
          this.loading = true
        })
        var currency = this.getCompanyDetail('currency')
        this.currency = this.getCurrencySymbol(currency)
        var data = {
          token: this.$session.get('token'),
          company_id: this.$session.get('selectedCompany')
        }
        var self = this
        // get product data
        if (self.$route.params.id) {
          var id = self.$route.params.id
          self.apiRequest('/customer/' + id, 'GET', data, function (response) {
            if (response.status === true) {
              var goodOrders = []
              for (var idx in response.data[0].orders) {
                if (response.data[0].orders[idx]['status'].id !== 'DRAFT') {
                  goodOrders.push(response.data[0].orders[idx])
                }
              }
              response.data[0].orders = goodOrders
              self.customer = response.data[0]

              self.$nextTick(function () {
                self.loading = false
              })
            }
          })
        }
      },
      addPoints () {
        var self = this
        if (!this.newPoints.money_spent || !this.newPoints.comments) {
          swal({
            toast: true,
            type: 'warning',
            text: self.$t('validations.validPoinsNo'),
            position: 'top-end',
            showConfirmButton: false,
            timer: 3000
          })
        } else {
          var id = this.$route.params.id
          var data = {
            user_id: id,
            token: this.$session.get('token'),
            company_id: this.$session.get('selectedCompany'),
            money_spent: this.newPoints.money_spent,
            comments: this.newPoints.comments,
            money_spent_confirm: 1
          }
          this.apiRequest('/loyalty-points', 'POST', data, function (response) {
            if (response.status === true) {
              swal(
                '',
                response.data.message,
                'success'
              )
              self.customer.loyalty_points = parseInt(response.data.loyalty_points)
              self.newPoints.money_spent = null
              self.newPoints.comments = null
            } else {
              swal(
                '',
                response.errors.company_id !== undefined ? response.errors.company_id : self.$t('customers.points'),
                'error'
              )
            }
          })
        }
      },
      goToRecord (row, event, column) {
        this.globalGoToRecord(row, event, column, '/orders/view/')
      }
    }
  }
</script>
<style>
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Customers/CustomerView.vue